import { useEffect, useState } from "react";
import * as api from "@/lib/api";
import { useData, useAction } from "@/hooks/useData";

/** Today's attendance record for one employee, a live elapsed timer, and punch actions. */
export function usePunchClock(employeeId, onChange) {
  const { data: today, reload } = useData(() => api.attendance.today(employeeId), [employeeId]);
  const { run, pending } = useAction();
  const [elapsed, setElapsed] = useState(0);

  const punchedIn = !!today?.punch_in;
  const punchedOut = !!today?.punch_out;

  useEffect(() => {
    if (!punchedIn || punchedOut) return;
    const tick = () => setElapsed(Math.floor((Date.now() - new Date(today.punch_in).getTime()) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [today, punchedIn, punchedOut]);

  const after = async ({ ok }) => { if (ok) { await reload(); onChange?.(); } };

  return {
    today,
    punchedIn,
    punchedOut,
    elapsed,
    pending,
    punchIn: () => run(() => api.attendance.punchIn(employeeId), "Punched in").then(after),
    punchOut: () => run(() => api.attendance.punchOut(employeeId), "Punched out").then(after),
  };
}
